import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UNIVERSAL from "../config/config";

const initialState = {
  data: "",
  loading: true,
  error: "",
};

export const fetchHomepageProfile = createAsyncThunk("/homePageProfile/fetchHomePageProfile", (data) => {
  return fetch(UNIVERSAL.BASEURL_1 + `/bizv2/homepage`, {
    method: "POST",
    headers: {
      "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
    },
    body: JSON.stringify({
      businessId: data.businessId,
      version: 5,
    }),
  })
    .then((response) => response.json())
    .then((res) => {
      return res;
    });
});

const fetchHomepageProfileSlice = createSlice({
  name: "homePageProfile",
  initialState,
  reducers: {
    resetHomePageProfile: (state, action) => {
      state.data = "";
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchHomepageProfile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHomepageProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(fetchHomepageProfile.rejected, (state, action) => {
      state.loading = false;
      state.data = "";
      state.error = action.error.message;
    });
  },
});

export default fetchHomepageProfileSlice;
export const { resetHomePageProfile } = fetchHomepageProfileSlice.actions;
